export default __webpack_public_path__ + "static/media/icon-weight.0ce2cbc6.svg";